/* ============================================================
   Crescent Bakes — site prototype 2026-09-04 · shared chrome
   (nav, cart storage, fly-to-bag FX). Loaded on every page.
   ============================================================ */
(function(){
"use strict";
var A=window.CBCDN;
var ROUTES=window.CB_SETTINGS||{};
/* Customer-facing label for an Appstle selling plan. The plan *name* stays the key everywhere
   (cart lines, menus, PDP chips); only the label is rewritten: "Once every two weeks" → "Every two weeks". */
window.CBPlanLabel=function(name){ return String(name==null?"":name).replace(/^Once every\s+/i,"Every "); };
var ROOT_URL=ROUTES.rootUrl||"/";
function storefrontRoute(path){return ROOT_URL.replace(/\/?$/,"/")+String(path||"").replace(/^\/+/,"");}

/* ---------------- landing on a fragment ----------------
   `html{scroll-behavior:smooth}` turns a fragment landing into an ANIMATED scroll, and on a fresh
   load that animation is cancelled by the layout still settling (images, fonts) — so
   /pages/about-us#how-it-works dropped you at the top of About instead of at "How it works", and
   the sticky bar had nothing to appear over (owner, 2026-09-11). Jump instantly for the landing,
   then hand smooth scrolling back for in-page clicks. Runs twice: once as soon as the document is
   parsed, once more after load, because late images move the target.
   Where the real header is pinned (About, Accessories, Bag) the offset is computed here rather than
   left to scroll-margin: scrollIntoView landed 3px short on phones, which showed a cream sliver above
   the white band and kept the header cream on arrival (2026-09-14). Rounded UP so no sliver can
   show. A link that changes the hash on the page itself gets the same exact target, smoothly. */
(function(){
  var root=document.documentElement;
  function target(){
    var id=location.hash.slice(1); if(!id) return null;
    try{ id=decodeURIComponent(id); }catch(e){}
    return document.getElementById(id);
  }
  function pinnedHeader(){
    var body=document.body, zoom=body?parseFloat(body.style.zoom||"1"):1;
    /* a zoomed body (wide desktops) mixes rect and scroll units; scroll-margin already lands flush there */
    if(!body||!body.classList.contains("cb-header-sticky")||(zoom&&zoom!==1)) return null;
    return document.querySelector("[data-cb-header]");
  }
  function exactTop(t,header){ return Math.ceil(t.getBoundingClientRect().top+(window.pageYOffset||0)-header.getBoundingClientRect().height); }
  function land(){
    var t=target(); if(!t) return;
    var prev=root.style.scrollBehavior, header=pinnedHeader();
    root.style.scrollBehavior="auto";
    if(header) window.scrollTo(0,exactTop(t,header)); else t.scrollIntoView({block:"start"});
    root.style.scrollBehavior=prev||"";
  }
  if(location.hash&&location.hash!=="#"){
    if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",land,{once:true});
    else land();
    addEventListener("load",land,{once:true});
  }
  addEventListener("hashchange",function(){
    var t=target(), header=pinnedHeader(); if(!t||!header) return;
    window.scrollTo({top:exactTop(t,header),behavior:"smooth"});
  });
})();

/* ---------------- Shopify Ajax Cart ---------------- */
function cartRequest(path,body){
  /* no-store: during a Back navigation the browser otherwise answers cart reads from its HTTP cache,
     handing the page the bag as it was BEFORE the customer left — the cart must always be live (2026-09-14) */
  var options={method:body?"POST":"GET",cache:"no-store",headers:{"Accept":"application/json"}};
  if(body){ options.headers["Content-Type"]="application/json"; options.body=JSON.stringify(body); }
  return fetch(path+".js",options).then(function(response){
    return response.text().then(function(bodyText){
      var payload=null,parsed=false;try{if(bodyText){payload=JSON.parse(bodyText);parsed=true;}}catch(parseError){}
      if(!response.ok){var failure=new Error(payload&&(payload.description||payload.message)||"Shopify could not apply that cart change");if(response.status>=400&&response.status<500&&parsed)failure.cartValidation=true;failure.details=payload;throw failure;}
      if(!parsed)throw new Error("Shopify returned an unreadable cart response");
      return payload;
    });
  });
}
function announceCart(cart){
  if(cart&&typeof cart.item_count==="number"&&window.CB_SETTINGS) window.CB_SETTINGS.cartCount=cart.item_count;
  document.dispatchEvent(new CustomEvent("cb:cart",{detail:cart}));
  document.dispatchEvent(new CustomEvent("cb-cart",{detail:cart}));
  return cart;
}
function cartTransaction(task){
  if(!navigator.locks||typeof navigator.locks.request!=="function") return Promise.resolve().then(task);
  return navigator.locks.request("crescentbakes-cart-v1",{mode:"exclusive"},task);
}
function cartScheduleDate(cart){
  var attributes=cart&&cart.attributes||{};
  var date=attributes.Fulfillment==="Pick up"?attributes["Pickup date"]:attributes["Delivery date"];
  return String(date||attributes["Pickup date"]||attributes["Delivery date"]||"").trim();
}
function pendingScheduleItems(cart,date){
  return (cart&&cart.items||[]).filter(function(item){
    var properties=item.properties||{};
    return properties.Schedule!==date||Object.prototype.hasOwnProperty.call(properties,"_cb_schedule_removed");
  });
}
function giftDesignKey(value){
  var key=String(value||"").toLowerCase();
  return key==="bread"||key==="bread money"?"bread":key==="gift"||key==="gift card"?"gift":null;
}
function pendingGiftDesign(item){
  if(!item.gift_card)return null;
  var properties=item.properties||{},wanted=giftDesignKey(properties._design)||giftDesignKey(properties.Design);
  var option=(item.options_with_values||[]).find(function(option){return String(option.name).toLowerCase()==="design";});
  return wanted&&wanted!==giftDesignKey(option&&option.value)?wanted:null;
}
var CBCart={
  get:function(){ return cartRequest(storefrontRoute("cart")).then(announceCart); },
  add:function(items){
    return cartRequest(storefrontRoute("cart/add"),{items:items}).catch(function(cause){if(cause&&cause.cartValidation)throw cause;var uncertain=new Error("Add may have completed — reload your bag to confirm");uncertain.cartCommitted=true;uncertain.cause=cause;throw uncertain;}).then(function(){
      return CBCart.get().catch(function(){
        return new Promise(function(resolve){setTimeout(resolve,250);}).then(function(){return CBCart.get();}).catch(function(cause){var error=new Error("Added — reload your bag to confirm");error.cartCommitted=true;error.cause=cause;throw error;});
      });
    });
  },
  change:function(payload){ return cartRequest(storefrontRoute("cart/change"),payload).catch(function(cause){if(cause&&cause.cartValidation)throw cause;var uncertain=new Error("Cart change may have completed — reload your bag to confirm");uncertain.cartCommitted=true;uncertain.cause=cause;throw uncertain;}).then(announceCart); },
  update:function(payload){ return cartRequest(storefrontRoute("cart/update"),payload).catch(function(cause){if(cause&&cause.cartValidation)throw cause;var uncertain=new Error("Cart update may have completed — reload your bag to confirm");uncertain.cartCommitted=true;uncertain.cause=cause;throw uncertain;}).then(announceCart); },
  clear:function(){ return cartRequest(storefrontRoute("cart/clear"),{}).then(announceCart); },
  /* Older carts stored artwork only as a property. Replace just those gift lines with
     their matching image variant before checkout, keeping the quantity and gift details. */
  prepareGiftCards:async function(cart){
    if(!(cart&&cart.items||[]).some(pendingGiftDesign))return cart;
    return cartTransaction(async function(){
      var current=await cartRequest(storefrontRoute("cart"));
      for(var item of current.items||[]){
        var design=pendingGiftDesign(item);
        if(!design)continue;
        var product=await cartRequest(storefrontRoute("products/"+encodeURIComponent(item.handle)));
        var index=(product.options||[]).findIndex(function(option){return String(option.name||option).toLowerCase()==="design";});
        if(index<0)continue; // Compatible with a theme preview before catalog migration.
        var variant=(product.variants||[]).find(function(variant){
          return giftDesignKey((variant.options||[])[index])===design&&Number(variant.price)===Number(item.original_price);
        });
        if(!variant||variant.available===false)throw new Error("That gift card design is unavailable");
        if(Number(variant.id)===Number(item.variant_id))continue;
        try{
          var transferred=(current.items||[]).find(function(line){return Number(line.variant_id)===Number(variant.id)&&(line.properties||{})._cb_gift_source===item.key;});
          if(transferred&&Number(transferred.quantity)!==Number(item.quantity))throw new Error("Gift card quantity changed during update");
          if(!transferred){
            var properties=Object.assign({},item.properties,{_cb_gift_source:item.key});
            await cartRequest(storefrontRoute("cart/add"),{items:[{id:variant.id,quantity:item.quantity,properties:properties}]});
          }
          current=await cartRequest(storefrontRoute("cart/change"),{id:item.key,quantity:0});
        }catch(cause){
          var error=new Error("Your gift card could not be updated. Reload your bag to confirm.");
          error.cartCommitted=true;error.cause=cause;throw error;
        }
      }
      return announceCart(current);
    });
  },
  /* Checkout lands on "Ship" unless the cart carries a delivery preference, so before leaving for checkout the
     board writes one through the Storefront API (public token = theme setting). Return false when Shopify does
     not confirm the requested preference: callers keep the customer on the page rather than opening checkout
     with the opposite toggle. Digital-only carts need no delivery preference. */
  preferDelivery:function(cart,choice){
    var token=ROUTES.storefrontToken;
    if(cart&&cart.requires_shipping===false)return Promise.resolve(true);
    if(!token||(!(cart&&cart.items||[]).length&&!Number(cart&&cart.item_count)))return Promise.resolve(false);
    var controller=typeof AbortController==="function"?new AbortController():null,timedOut=false,timer;
    /* Resolve on the deadline even if fetch ignores abort. This also bounds the Ajax-token refresh. */
    var deadline=new Promise(function(resolve){timer=setTimeout(function(){timedOut=true;if(controller)controller.abort();resolve(false);},4000);});
    /* Liquid's embedded cart JSON can omit the token even when the bag is already saved. Fetch the
       same Ajax cart once so the Storefront mutation receives its full token + secret key. */
    var ready=cart.token?Promise.resolve(cart):cartRequest(storefrontRoute("cart"));
    var request=ready.then(function(fresh){
      if(timedOut)return false;
      if(fresh&&fresh.requires_shipping===false)return true;
      var cartToken=fresh&&fresh.token;
      if(!cartToken||!(fresh.items||[]).length)return false;
      var pickup=!!(choice&&choice.pickup),method=pickup?"PICK_UP":"SHIPPING",delivery={deliveryMethod:[method],pickupHandle:[]};
      var locationId=String(choice&&choice.locationId||"").trim().replace(/^gid:\/\/shopify\/Location\//,"");
      if(pickup&&locationId)delivery.pickupHandle=[locationId];
      var cartId=/^gid:\/\/shopify\/Cart\//.test(cartToken)?cartToken:"gid://shopify/Cart/"+cartToken;
      /* Shared shopifypreview.com links serve the theme, but return 404 for the Storefront API.
         Use the permanent shop domain already supplied by Liquid, including in theme previews. */
      var endpoint=(ROUTES.shop?"https://"+ROUTES.shop:"")+"/api/2026-07/graphql.json";
      return fetch(endpoint,{method:"POST",signal:controller?controller.signal:undefined,headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":token},
        body:JSON.stringify({query:"mutation($id:ID!,$b:CartBuyerIdentityInput!){cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:$b){cart{buyerIdentity{preferences{delivery{deliveryMethod pickupHandle}}}} userErrors{field message}}}",variables:{id:cartId,b:{preferences:{delivery:delivery}}}})})
        .then(function(response){if(!response.ok)throw new Error("Delivery preference request failed ("+response.status+")");return response.json();})
        .then(function(payload){
          if(timedOut)return false;
          var result=payload&&payload.data&&payload.data.cartBuyerIdentityUpdate,errors=[].concat(result&&result.userErrors||[],payload&&payload.errors||[]);
          var saved=result&&result.cart&&result.cart.buyerIdentity&&result.cart.buyerIdentity.preferences&&result.cart.buyerIdentity.preferences.delivery;
          var methods=saved&&saved.deliveryMethod||[],handles=saved&&saved.pickupHandle||[],handle=String(handles[0]||"").replace(/^gid:\/\/shopify\/Location\//,"");
          var methodSaved=methods[0]===method,locationSaved=!pickup||!locationId||handle===locationId;
          if(errors.length||!methodSaved||!locationSaved){console.warn("Delivery preference skipped",errors.length?errors:"Shopify did not confirm the selected method and location");return false;}
          return true;
        });
    }).catch(function(error){console.warn("Delivery preference skipped",error);return false;});
    return Promise.race([request,deadline]).then(function(ok){clearTimeout(timer);return ok;});
  },
  schedulePending:function(cart){
    return pendingScheduleItems(cart,cartScheduleDate(cart)).length>0;
  },
  syncSchedule:function(snapshot,onChange){
    /* Called inside the existing cart transaction, after saving order attributes.
       Reuse its fresh cart; never acquire a nested lock or add a redundant GET. */
    return Promise.resolve(snapshot).then(function stamp(cart){
        if(!(cart&&cart.items||[]).length)return cart;
        var date=cartScheduleDate(cart);
        if(!date)throw new Error("Choose a schedule date before checking out.");
        var items=pendingScheduleItems(cart,date);if(!items.length)return cart;
        var item=items[0],properties=Object.assign({},item.properties);
        properties.Schedule=date;
        delete properties._cb_schedule_removed;
        return CBCart.change({id:item.key,quantity:item.quantity,properties:properties}).then(function(next){
          if(onChange)onChange(next);
          if(pendingScheduleItems(next,cartScheduleDate(next)).length>=items.length)throw new Error("Could not save the item schedule. Please try again.");
          /* Properties change line keys and can merge lines; use each returned cart. */
          return stamp(next);
        });
    });
  },
  count:function(){ return window.CB_SETTINGS&&window.CB_SETTINGS.cartCount||0; },
  transaction:cartTransaction
};

/* Legacy presentation state remains temporarily available to prototype-only pages.
   It is never cleared on session start; commerce pages use CBCart above. */
var CBCART={
  KEY:"cb-cart-v3",
  load:function(){
    try{ var s=JSON.parse(localStorage.getItem(this.KEY)||"null"); if(s&&typeof s==="object") return s; }catch(e){}
    return {q:{},extras:{},mode:"one",freq:null,fulfil:"delivery",date:null,venue:0};
  },
  save:function(s){ try{ localStorage.setItem(this.KEY,JSON.stringify(s)); }catch(e){} document.dispatchEvent(new CustomEvent("cb-cart")); },
  count:function(){
    var s=this.load(),n=0,k;
    for(k in s.q){ n+=(s.q[k].one||0)+(s.q[k].sub||0); }
    for(k in s.extras){ n+=s.extras[k]||0; }
    return n;
  },
  addProduct:function(id,mode,delta){
    var s=this.load(); s.q=s.q||{}; var q=s.q[id]||(s.q[id]={one:0,sub:0});
    q[mode==="sub"?"sub":"one"]=Math.max(0,Math.min(24,(q[mode==="sub"?"sub":"one"]||0)+delta));
    if(!q.one&&!q.sub) delete s.q[id];
    this.save(s);
  },
  addExtra:function(id,delta){
    var s=this.load(); s.extras=s.extras||{};
    s.extras[id]=Math.max(0,Math.min(24,(s.extras[id]||0)+delta));
    if(!s.extras[id]) delete s.extras[id];
    this.save(s);
  }
};
/* extras catalog shared by accessories + bag/rail */
var CBEXTRAS={
  "tote":{name:"Tote Bag(uette)",sub:"",price:30,img:A+"accessories-tote-icon.webp"},
  "gc-10":{name:"Digital Gift Card",sub:"$10 · sent by email",price:10,img:A+"icons-giftcard-thumb.svg"},
  "gc-25":{name:"Digital Gift Card",sub:"$25 · sent by email",price:25,img:A+"icons-giftcard-thumb.svg"},
  "gc-50":{name:"Digital Gift Card",sub:"$50 · sent by email",price:50,img:A+"icons-giftcard-thumb.svg"},
  "gc-100":{name:"Digital Gift Card",sub:"$100 · sent by email",price:100,img:A+"icons-giftcard-thumb.svg"}
};

/* ---------------- status-bar tint (iOS) ----------------
   The page cannot draw under the iPhone status bar, so a fixed backdrop never blurs it. Safari
   does tint that strip from <meta name="theme-color">, so while any overlay is up the theme
   colour becomes the backdrop's grey over cream — the same tone the blur settles to. */
(function(){
  var CREAM="#f9f0ea", DIM="#a29c98", LIGHT="#ccc4bf";   /* heavy scrim / bottom-sheet scrim, each composited over cream */
  /* With nothing up, the strip must be the colour of the page it joins — the product template is
     white, not cream, and hard-coding cream left a visible seam there (owner, 2026-09-11). */
  var REST=CREAM;
  function restColour(){
    var solid=function(el){
      if(!el) return "";
      var c=getComputedStyle(el).backgroundColor;
      return (c&&c!=="transparent"&&c.indexOf("rgba(0, 0, 0, 0)")<0)?c:"";
    };
    return solid(document.body)||solid(document.documentElement)||CREAM;
  }
  /* the mobile menu is NOT in here: its cream panel runs under the status bar, so cream is correct there */
  var HEAVY=".pdp-backdrop.show,.rvm-backdrop.show", SHEET=".sheet-backdrop.show,.bagsheet-backdrop.show";
  function meta(){
    var m=document.querySelector('meta[name="theme-color"]');
    if(!m){ m=document.createElement("meta"); m.name="theme-color"; m.content=CREAM; document.head.appendChild(m); }
    return m;
  }
  var cur=null, pending=null;
  function paint(want){
    var m=meta(); m.content=want;
    /* iOS Safari can keep painting the old tint after a plain content change — swap the element out */
    var n=document.createElement("meta"); n.name="theme-color"; n.content=want;
    m.parentNode.replaceChild(n,m);
  }
  function sync(){
    var heavy=!!document.querySelector(HEAVY), sheet=!heavy&&!!document.querySelector(SHEET);
    /* desktop scrims are cream, so the browser tint stays the page's own tone there; only phones go grey (2026-09-16) */
    var want=heavy?(matchMedia("(max-width:767px)").matches?DIM:REST):sheet?LIGHT:REST;
    if(want===cur) return; cur=want;
    /* both classes in the same task, so the cap appears already in the right tone.
       The cap and the body tone now FADE between tones (see .cb-topcap in site.css) instead of
       snapping, because the backdrop behind them takes .45s to fade out. */
    document.body.classList.toggle("cb-sheet",sheet);
    document.body.classList.toggle("cb-dim",heavy||sheet);   /* Safari 26 reads CSS, not the meta */
    /* Going back to cream there is still a scrim on screen for .45s, and <meta theme-color> is
       not animatable — iOS repaints the strip at once, which is the change you could see when an
       overlay closed (owner, 2026-09-11). Hold the revert until the fade is over; opening, and
       any change between two scrim tones, still paints immediately. */
    clearTimeout(pending); pending=null;
    if(want===REST) pending=setTimeout(function(){ pending=null; paint(want); },470);
    else paint(want);
  }
  /* A sticky header that changes tone (About, over "How it works") is what the strip joins, so it can
     move the resting tone; null returns to the page's own background. While a scrim is up the scrim's
     tone wins and the new resting tone applies when it closes. */
  window.CBStatusBar={setRest:function(color){
    REST=color||restColour();
    if(document.querySelector(HEAVY)||document.querySelector(SHEET)) return;
    clearTimeout(pending); pending=null; cur=REST; paint(REST);
  }};
  function start(){
    if(!document.querySelector(".cb-topcap")){ var c=document.createElement("div"); c.className="cb-topcap"; document.body.appendChild(c); }
    REST=restColour();
    cur=null; sync();
    /* the whole document, not just the body element: every scrim toggles `.show` on its own
       node, so a body-only observer never saw the bag or delivery sheets open (owner, 2026-09-11) */
    if(window.MutationObserver) new MutationObserver(sync).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:["class"]});
  }
  if(document.body) start(); else document.addEventListener("DOMContentLoaded",start);
})();

/* ---------------- nav ---------------- */
var PAGES=[
  {id:"home",label:"Shop bakes",href:ROUTES.rootUrl||"/"},
  {id:"how",label:"How it works",href:(ROUTES.aboutUrl||"/pages/about-us")+"#how-it-works",icon:"nav-how.svg",pos:"left:9.81%;top:14.58%;width:80.39%;height:70.86%"},
  {id:"catering",label:"Events & Catering",href:ROUTES.cateringUrl||"/pages/events-catering",icon:"nav-cloche.svg",cloche:true},
  {id:"about",label:"About",href:ROUTES.aboutUrl||"/pages/about-us",icon:"nav-apron.svg",pos:"left:16.29%;top:16.29%;width:67.54%;height:67.5%"},
  {id:"accessories",label:"Accessories",href:ROUTES.accessoriesUrl||"/pages/accessories",icon:"nav-tote.svg",pos:"left:19.72%;top:19.74%;width:60.8%;height:60.77%"},
  {id:"track",label:"Track orders",href:ROUTES.accountUrl||"/account",icon:"nav-person.svg",pos:"left:25.29%;top:22.95%;width:49.38%;height:54.6%"},
  {id:"bag",label:"Bag",href:ROUTES.cartUrl||"/cart",icon:"nav-tote-baguette.svg",pos:"left:23.22%;top:18.21%;width:54.07%;height:63.65%"}
];
function menuHTML(active){
  return '<div class="cbn-menu-backdrop" data-cb-menu-backdrop></div>'+
    '<nav class="cbn-menu" id="cbMobileMenu" data-cb-menu aria-label="Mobile navigation" aria-hidden="true" inert>'+
    '<button class="cbn-menu-close" data-cb-menu-close aria-label="Close"><svg width="14" height="14" viewBox="0 0 18 18" fill="none"><path d="M3 3l12 12M15 3 3 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>'+
    PAGES.map(function(p){ return '<a href="'+p.href+'"'+(p.id===active?' data-on="true"':"")+'>'+p.label+'</a>'; }).join("")+
    '</nav>';
}
var WIRED_BURGERS=(typeof WeakSet==="function")?new WeakSet():{has:function(){return false;},add:function(){}};
function wireMenu(){
  var menu=document.querySelector("[data-cb-menu]"),bd=document.querySelector("[data-cb-menu-backdrop]");
  if(!menu) return;
  if(!menu.id)menu.id="cbMobileMenu";
  if(!menu._cbMenuState){
    var opener=null;
    function focusable(){return [].slice.call(menu.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(element){return element.offsetParent!==null;});}
    function close(restore){
      if(!menu.classList.contains("show"))return;
      menu.classList.remove("show");if(bd)bd.classList.remove("show");menu.setAttribute("aria-hidden","true");menu.setAttribute("inert","");
      document.querySelectorAll("[data-cb-burger]").forEach(function(button){button.setAttribute("aria-expanded","false");});
      var returnTo=opener;opener=null;if(restore!==false&&returnTo&&returnTo.isConnected)setTimeout(function(){returnTo.focus();},420);
    }
    function open(button){
      opener=button||document.activeElement;menu.removeAttribute("inert");menu.setAttribute("aria-hidden","false");menu.classList.add("show");if(bd)bd.classList.add("show");
      document.querySelectorAll("[data-cb-burger]").forEach(function(trigger){trigger.setAttribute("aria-expanded","true");});
      requestAnimationFrame(function(){var first=focusable()[0];if(first)first.focus();});
    }
    menu._cbMenuState={open:open,close:close};
    var x=menu.querySelector("[data-cb-menu-close]");if(x)x.addEventListener("click",function(){close();});
    if(bd)bd.addEventListener("click",function(){close();});
    menu.addEventListener("keydown",function(event){if(event.key!=="Tab")return;var nodes=focusable();if(!nodes.length)return;var first=nodes[0],last=nodes[nodes.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}});
    addEventListener("keydown",function(event){if(event.key==="Escape")close();});
  }
  document.querySelectorAll("[data-cb-burger]").forEach(function(b){
    b.setAttribute("aria-controls",menu.id);if(!b.hasAttribute("aria-expanded"))b.setAttribute("aria-expanded","false");
    /* a WeakSet, not a data attribute: the sticky bar clones the header, and a cloned attribute would mark the new burger as already wired */
    if(WIRED_BURGERS.has(b))return;WIRED_BURGERS.add(b);
    b.addEventListener("click",function(){ if(menu.classList.contains("show")) menu._cbMenuState.close(); else menu._cbMenuState.open(b); });
  });
}
function updateBadges(){
  var n=CBCart.count();
  document.querySelectorAll("[data-cb-badge]").forEach(function(el){
    el.dataset.show=n>0; el.textContent=n>9?"9+":String(n);
  });
}

/* every page fills the width like the homepage: 1.2x cap (15" MBP "More Space") */
function fitScale(){ document.body.style.zoom=window.CB_SETTINGS&&window.CB_SETTINGS.desktopZoom!==false&&innerWidth>1440?String(Math.min(innerWidth/1440,1.2)):""; }

/* Handwriting is an optional enhancement; neither its player nor its glyph data
   participates in the deferred script chain used by navigation and ordering. */
function isMobile(){ return matchMedia("(max-width:767px)").matches; }
function handwriting(){
  var host=document.getElementById("handwrite");
  if(!host||host.firstChild||host.dataset.handwritingPending) return;
  host.dataset.handwritingPending="true";
  function fallback(){var phrases=ROUTES.handwritingPhrases||[];host.textContent=phrases.find(function(value){return String(value).trim();})||"Hands in, additive out.";}
  function start(){
    var script=document.createElement("script");
    script.src=ROUTES.handwritingPlayer||A+"handwriting-player.js";script.async=true;
    script.onload=function(){if(window.CBHandwriting)CBHandwriting.draw(host,ROUTES.handwriting||A+"handwriting.json",ROUTES.handwritingPhrases,ROUTES.handwritingGlyphs||A+"handwriting-glyphs.json").catch(fallback);else fallback();};
    script.onerror=fallback;document.head.appendChild(script);
  }
  if(window.requestIdleCallback)requestIdleCallback(start,{timeout:1800});else setTimeout(start,0);
}
/* announcement strip: when the line is wider than the bar (phones), its dot-separated parts take turns,
   sliding up every few seconds; a part that is still too wide crawls to its end and back (owner, 2026-09-16) */
function announceTicker(){
  [].forEach.call(document.querySelectorAll("[data-announce]"),function(bar){
    if(bar.dataset.tick) return;
    var full=bar.textContent.replace(/\s+/g," ").trim(), parts=full.split(/\s*[·•]\s*/).filter(Boolean), timer=0, idx=0;
    function flat(){ clearInterval(timer); clearTimeout(timer); bar.textContent=full; }
    function build(){
      flat();
      var cs=getComputedStyle(bar), room=bar.clientWidth-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight);
      if(bar.scrollWidth<=bar.clientWidth+1||parts.length<2||getComputedStyle(bar).display==="none") return;
      var vp=document.createElement("span"); vp.className="ann-vp";
      parts.forEach(function(p,i){
        var it=document.createElement("span"); it.className="ann-item"+(i?"":" on");
        var t=document.createElement("span"); t.textContent=p; it.appendChild(t); vp.appendChild(it);
      });
      bar.textContent=""; bar.appendChild(vp);
      var items=vp.children;
      [].forEach.call(items,function(it){
        var over=it.firstChild.scrollWidth-room;
        if(over>2){ it.style.textAlign="left"; it.style.setProperty("--shift",(-over-2)+"px"); it.style.setProperty("--crawl",Math.max(3.2,over/22+2.4)+"s"); it.dataset.crawl="1"; }
      });
      var go=function(it){ if(it.dataset.crawl){ it.classList.remove("crawl"); void it.offsetWidth; it.classList.add("crawl"); } };
      go(items[0]); idx=0;
      if(matchMedia("(prefers-reduced-motion:reduce)").matches) return;
      /* owner 2026-09-21: 4.2s between messages read as a stall. Each message now holds for 2.6s —
         except one that has to crawl to its end, which keeps its animation plus a beat to be read. */
      var DWELL=2600;
      var dwellFor=function(it){ var c=parseFloat(it.style.getPropertyValue("--crawl"))||0; return c?Math.round(c*1000)+1300:DWELL; };
      var step=function(){
        if(!bar.isConnected){flat();return;}
        var cur=items[idx], nxt=items[(idx+1)%items.length];
        cur.classList.remove("on"); cur.classList.add("out");
        setTimeout(function(){ cur.classList.remove("out","crawl"); },650);
        nxt.classList.add("on"); go(nxt); idx=(idx+1)%items.length;
        timer=setTimeout(step,dwellFor(nxt));
      };
      timer=setTimeout(step,dwellFor(items[0]));
    }
    bar.dataset.tick="1"; build();
    var w=innerWidth,onResize=function(){if(!bar.isConnected){flat();removeEventListener("resize",onResize);return;}if(innerWidth!==w){w=innerWidth;build();}};addEventListener("resize",onResize);
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(build);
  });
}
/* Optical centring for pill badges (owner, 2026-09-16: "optically centred, always"). Caps with letter-spacing carry a
   trailing space after the last letter, and words like POPULAR or DIGITAL are heavier on one side, so geometric centring
   reads off by up to ~1.5px. Each label is drawn once to a canvas in its own font; the correction is half-way between
   its ink bounding box and its ink mass, applied by moving padding from one side to the other (the pill never resizes).
   Cached per font+text; re-run when badges are rendered or fonts load. */
var CBOptical=(function(){
  var SEL=".badge,.mbadge,.save-pill,.pdx-ybadge,.rvm-ver,[data-optical]", cache={}, cv=null, ctx=null, timer=0;
  function offset(el){
    var cs=getComputedStyle(el), txt=(el.textContent||"").replace(/\s+/g," ").trim();
    if(!txt||cs.display==="none") return null;
    if(cs.textTransform==="uppercase") txt=txt.toUpperCase();
    var fs=parseFloat(cs.fontSize)||10, ls=parseFloat(cs.letterSpacing)||0, S=8;
    var font=cs.fontStyle+" "+cs.fontWeight+" "+(fs*S)+"px "+cs.fontFamily, key=font+"|"+ls+"|"+txt;
    if(key in cache) return cache[key];
    if(document.fonts&&document.fonts.check&&!document.fonts.check(cs.fontWeight+" "+fs+"px "+cs.fontFamily)) return null;
    if(!cv){ cv=document.createElement("canvas"); ctx=cv.getContext("2d",{willReadFrequently:true}); }
    ctx.font=font;
    var chars=Array.from(txt), x=0, pos=[];
    chars.forEach(function(ch){ pos.push(x); x+=ctx.measureText(ch).width+ls*S; });
    var pad=Math.ceil(fs*S), W=Math.ceil(x+pad*2), H=Math.ceil(fs*S*2.2);
    cv.width=W; cv.height=H; ctx.font=font; ctx.textBaseline="middle"; ctx.fillStyle="#000";
    chars.forEach(function(ch,i){ ctx.fillText(ch,pad+pos[i],H/2); });
    var d=ctx.getImageData(0,0,W,H).data, lo=W, hi=-1, mass=0, sum=0;
    for(var cx=0;W>cx;cx++){ var col=0; for(var cy=0;H>cy;cy++) col+=d[(cy*W+cx)*4+3]; if(col>0){ if(lo>cx) lo=cx; hi=cx; mass+=col; sum+=col*(cx+.5); } }
    if(0>hi) return (cache[key]=0);
    var box=pad+x/2, ink=((lo+hi+1)/2+sum/mass)/2;
    return (cache[key]=Math.round((box-ink)/S*100)/100);
  }
  function apply(root){
    [].forEach.call((root||document).querySelectorAll(SEL),function(el){
      if(el.dataset.opticalBase==null){ var cs=getComputedStyle(el); el.dataset.opticalBase=((parseFloat(cs.paddingLeft)+parseFloat(cs.paddingRight))/2)||0; }
      var off=offset(el); if(off==null) return;
      var base=+el.dataset.opticalBase;
      el.style.paddingLeft=(base+off)+"px"; el.style.paddingRight=Math.max(0,base-off)+"px";
    });
  }
  function soon(){ clearTimeout(timer); timer=setTimeout(function(){ apply(document); },60); }
  function start(){
    apply(document);
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(soon);
    if(window.MutationObserver) new MutationObserver(function(recs){
      for(var i=0;recs.length>i;i++){ var n=recs[i].target; if(n.nodeType===1&&(n.matches(SEL)||n.querySelector(SEL))){ soon(); return; } }
    }).observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",start); else start();
  return {apply:apply};
})();
/* Footer seal ring: the words must wrap the whole circle. textLength on the textPath does that in Chrome and Safari (and
   keeps the gap across the loop's seam even), but Firefox ignores it and the text stopped two-thirds of the way round
   (owner, 2026-09-17). So check the result: if the text does not reach round the circle, drop textLength and share the
   remainder out as letter-spacing on every character instead. Re-runs once the webfont has loaded. */
function fitSealRing(){
  [].forEach.call(document.querySelectorAll(".cb-foot .ring textPath"),function(tp){
    var path=document.getElementById((tp.getAttribute("href")||tp.getAttribute("xlink:href")||"").replace("#",""));
    var text=tp.parentNode, n=Array.from(tp.textContent||"").length;
    if(!path||!n||!path.getTotalLength||!text.getStartPositionOfChar) return;
    var full=path.getTotalLength();
    if(!tp.dataset.fit){
      /* how far round the text actually runs, first glyph to last, measured along the circle */
      var box=path.getBBox(), cx=box.x+box.width/2, cy=box.y+box.height/2, r=box.width/2;
      try{
        var a0=text.getStartPositionOfChar(0), a1=text.getEndPositionOfChar(n-1);
        var d=Math.atan2(a1.y-cy,a1.x-cx)-Math.atan2(a0.y-cy,a0.x-cx); while(0>d) d+=2*Math.PI;
        if(d*r>full*0.9) return;                 /* textLength honoured — leave it */
      }catch(e){ return; }
      tp.dataset.fit="spacing";
      tp.removeAttribute("textLength"); tp.removeAttribute("lengthAdjust");
    }
    text.style.letterSpacing="0px";
    var natural=tp.getComputedTextLength();
    if(natural>0&&full>natural) text.style.letterSpacing=((full-natural)/n)+"px";
  });
}
if(document.fonts){ if(document.fonts.ready) document.fonts.ready.then(fitSealRing); if(document.fonts.addEventListener) document.fonts.addEventListener("loadingdone",fitSealRing); }
/* footer tablecloth edge: exactly the viewport's width whatever zoom sits above it. Measures how many screen px one
   CSS px is at the element itself (Safari and Chrome disagree under zoom), then sets width/offset from real rects. */
function fitFootCloth(){
  var vw=document.documentElement.clientWidth;
  [].forEach.call(document.querySelectorAll(".cb-foot .gingham,[data-bleed]"),function(g){
    g.style.marginLeft="0px"; g.style.width="1000px";
    var r=g.getBoundingClientRect(), ratio=r.width/1000;
    if(!(ratio>0)) return;
    g.style.width=(vw/ratio)+"px";
    g.style.marginLeft=(-r.left/ratio)+"px";
  });
}
var CBNAV={
  wire:function(opts){
    announceTicker();
    fitFootCloth();fitSealRing();
    if(!CBNAV._baseWired){CBNAV._baseWired=true;addEventListener("resize",fitFootCloth);addEventListener("load",fitFootCloth);addEventListener("load",fitSealRing);document.addEventListener("cb-cart",updateBadges);addEventListener("storage",updateBadges);}
    opts=opts||{};
    if(!document.querySelector("[data-cb-menu]")) document.body.insertAdjacentHTML("beforeend",menuHTML(opts.active||""));
    wireMenu();
    updateBadges();
    if(opts.zoom!==false){ fitScale(); addEventListener("resize",fitScale); fitFootCloth(); }
    /* Only request the optional handwriting player at breakpoints that show it. */
    if(opts.handwrite===true){
      var handwritingMedia=matchMedia("(min-width:1180px), (max-width:767px)");
      var startHandwriting=function(){if(handwritingMedia.matches)handwriting();};
      startHandwriting();
      if(!handwritingMedia.matches){
        var onHandwritingMedia=function(){if(!handwritingMedia.matches)return;startHandwriting();if(handwritingMedia.removeEventListener)handwritingMedia.removeEventListener("change",onHandwritingMedia);else handwritingMedia.removeListener(onHandwritingMedia);};
        if(handwritingMedia.addEventListener)handwritingMedia.addEventListener("change",onHandwritingMedia);else handwritingMedia.addListener(onHandwritingMedia);
      }
    }
    /* phones always get the sticky bar; desktop only where a page asks for it (sticky:true) */
    /* About, Accessories and Bag pin the real header (stickyHeader); every other page keeps the clone */
    if(opts.stickyHeader) stickyHeader(opts.whiteOver,opts);
    else if(opts.sticky!==false) stickyNav(opts.whiteOver,{from:opts.stickyFrom,mobileOnly:opts.sticky!==true||!!opts.stickyMobileOnly});
  }
};

/* Shopify may replace section DOM without executing its inline scripts. Replay only the
   scripts explicitly marked by our interaction-heavy sections. Their initializers abort
   their previous document/window listeners before binding the fresh section DOM. */
if(window.Shopify&&Shopify.designMode&&!window._cbEditorSectionReload){
  window._cbEditorSectionReload=true;
  document.addEventListener("shopify:section:load",function(event){
    var section=event.target;
    if(!section)return;
    var scripts=[].slice.call(section.querySelectorAll("script[data-cb-section-script]"));
    scripts.forEach(function(source){
      /* Shopify can reuse the section wrapper while replacing its children. Track the
         source node, so fresh scripts still run and a duplicate load event does not. */
      if(source.dataset.cbEditorExecuted==="true")return;
      source.dataset.cbEditorExecuted="true";
      var replay=document.createElement("script");
      replay.textContent=source.textContent;
      document.head.appendChild(replay);replay.remove();
    });
  });
  document.addEventListener("shopify:section:unload",function(event){
    var section=event.target;
    if(!section)return;
    if(((section.matches&&section.matches(".cb-home-section"))||section.querySelector(".cb-home-section"))&&window.CBHomeDestroy)window.CBHomeDestroy(section);
    if(section.querySelector("#proot, #proot-simple")&&window.CBProductDestroy)window.CBProductDestroy(section);
    if(section.querySelector("[data-cart-page]")&&window._cbCartPageAbort)window._cbCartPageAbort.abort();
    if(section.querySelector(".ab")){
      if(window._cbAboutFitAbort)window._cbAboutFitAbort.abort();
      if(window._cbAboutStorageAbort)window._cbAboutStorageAbort.abort();
    }
  });
}

/* ---------------- sticky nav ----------------
   Deep links land you mid-page (the nav's own "How it works" jumps to
   /?view=about#how-it-works) with the header already scrolled away, so you lose all sense
   of where you are. A clone of the header slides down once you are past the real one. */
/* ---------------- sticky header (no clone) ----------------
   About, Accessories and Bag keep the real header pinned to the top the whole way down, so nothing
   swaps or slides in (owner, 2026-09-14). Stickiness itself is CSS (body.cb-header-sticky is set in
   the layout); this only adds the soft shadow once the page has moved and, on About, turns the header
   white over the white "How it works" band and back again. */
function stickyHeader(whiteOverSel,so){
  var header=document.querySelector("[data-cb-header]");
  if(!header||header.dataset.cbSticky==="true") return;
  header.dataset.cbSticky="true";
  document.body.classList.add("cb-header-sticky");
  var whiteEl=null, lastWhite=null, lastTone=null;
  /* overBand (About): the header takes the colour of the band under its bottom edge, blending through the band's
     cream fades, so it never jumps (owner, 2026-09-16). Band = [data-bleed] inside the section; fade = --hiw-fade. */
  function hex(c){ return "#"+c.map(function(v){ return ("0"+Math.round(v).toString(16)).slice(-2); }).join(""); }
  function rgb(h){ h=h.replace("#",""); return [0,2,4].map(function(i){ return parseInt(h.substr(i,2),16); }); }
  function bandTone(){
    var sec=document.querySelector(whiteOverSel), band=sec&&sec.querySelector("[data-bleed]");
    if(!band) return null;
    var r=band.getBoundingClientRect(), edge=header.getBoundingClientRect().bottom;
    var cs=getComputedStyle(band), ratio=band.offsetHeight?r.height/band.offsetHeight:1;
    var fade=(parseFloat(cs.getPropertyValue("--hiw-fade"))||88)*ratio;
    var t=Math.max(0,Math.min(1,(edge-r.top)/fade,(r.bottom-edge)/fade));
    var a=rgb(so.pageColor||"#f9f0ea"), b=rgb(so.overBand);
    return t<=0?null:hex(a.map(function(v,i){ return v+(b[i]-v)*t; }));
  }
  function update(){
    var y=window.pageYOffset||document.documentElement.scrollTop||0;
    header.classList.toggle("scrolled",y>2);
    if(!whiteOverSel) return;
    if(so&&so.overBand){
      var tone=bandTone();
      if(tone===lastTone) return;
      lastTone=tone;
      header.style.backgroundColor=tone||"";
      if(window.CBStatusBar) CBStatusBar.setRest(tone);
      return;
    }
    if(!whiteEl||!whiteEl.isConnected) whiteEl=document.querySelector(whiteOverSel);
    var white=false;
    if(whiteEl){
      var r=whiteEl.getBoundingClientRect(), edge=header.getBoundingClientRect().bottom;
      white=r.top-2<=edge&&r.bottom>edge;
    }
    if(white===lastWhite) return;
    lastWhite=white;
    header.classList.toggle("on-white",white);
    /* the status-bar strip joins this header, so it takes the same tone */
    if(window.CBStatusBar) CBStatusBar.setRest(white?"#ffffff":null);
  }
  var settle=null;
  var onScroll=function(){ update(); clearTimeout(settle); settle=setTimeout(update,160); };
  addEventListener("scroll",onScroll,{passive:true});
  addEventListener("scrollend",onScroll);
  addEventListener("resize",onScroll);
  addEventListener("hashchange",onScroll);
  addEventListener("load",onScroll);
  update();
}

function stickyNav(whiteOverSel,so){
  so=so||{};
  var header=document.querySelector("[data-cb-header], .nav#nav");
  var previous=document.querySelector(".cbn-stick");if(previous&&previous._cbCleanup)previous._cbCleanup();if(previous)previous.remove();
  if(!header)return;
  var stick=document.createElement("div"); stick.className="cbn-peek cbn-stick";
  var stickyAbort=new AbortController(),stickyOn=function(type,handler,options){var config=Object.assign({},options||{}, {signal:stickyAbort.signal});addEventListener(type,handler,config);};
  var clone=header.cloneNode(true);
  clone.removeAttribute("id");
  [].forEach.call(clone.querySelectorAll("[id]"),function(n){ n.removeAttribute("id"); });
  /* the announce strip belongs to the top of the page, not to a compact sticky bar */
  [].forEach.call(clone.querySelectorAll(".cbn-announce,.announce,.cbn-hand,.handwrite"),function(n){ n.remove(); });
  stick.appendChild(clone); document.body.appendChild(stick);
  wireMenu(); updateBadges();
  var shown=false, fromEl=null;
  /* the bar normally appears once the real header has scrolled away; a page can instead
     name a section (`stickyFrom`) so it only shows from there on — the homepage keeps its
     top half bar-free and gains the nav for the lower half — and restrict it to phones */
  function threshold(){
    if(so.from){
      if(!fromEl||!fromEl.isConnected) fromEl=document.querySelector(so.from);
      if(fromEl) return (window.pageYOffset||0)+fromEl.getBoundingClientRect().top-74;
    }
    return header.offsetHeight+30;
  }
  /* The bar is simply sticky: once you are past the threshold it stays put, on every page and
     both breakpoints (owner, 2026-09-11 — this replaces the phone-only "follow the scroll
     direction" rule, which also meant an anchored landing arrived with no bar at all because
     nothing had scrolled up yet). The homepage sets its own, later threshold via `stickyFrom`. */
  function check(){
    var y=(window.pageYOffset||document.documentElement.scrollTop||0);
    var phone=matchMedia("(max-width:767px)").matches;
    var past=y > threshold();
    if(so.mobileOnly&&!phone) past=false;
    if(past===shown) return;
    shown=past;
    /* Handing back to the real header has to be instant. The clone takes .42s to slide up, and
       scrolling up covers the last 30px of that gap in a frame or two — so the header arrived
       while the clone was still sliding and you saw two navs at once (owner, 2026-09-11).
       Only this one transition is suppressed: hiding on a phone scroll-down still slides. */
    stick.classList.toggle("nofade",!past&&y<=threshold());
    stick.classList.toggle("show",past);
    stick.style.pointerEvents=past?"auto":"none";
    if(past) updateBadges();
  }
  /* over a white band the bar turns white with it, so it never floats as a cream
     rectangle on top of the section it is sitting over */
  /* resolved lazily — the nav is injected at the top of the document, long before the section
     it has to match exists in the DOM */
  var whiteEl=null;
  function tint(){
    if(!whiteOverSel) return;
    if(!whiteEl||!whiteEl.isConnected) whiteEl=document.querySelector(whiteOverSel);
    if(!whiteEl) return;
    /* compare against the bar's RENDERED bottom, not a literal 74: under the page zoom
       (body zoom 1.2 on wide windows) every rect is in screen px, so 74 CSS px reads 89 */
    var r=whiteEl.getBoundingClientRect(), barBottom=stick.getBoundingClientRect().bottom;
    /* a 2px tolerance: the anchored landing puts the band's top EXACTLY at the bar's
       bottom, and under zoom both are fractional screen px (88.8), so a strict <= is a
       coin flip on float noise */
    stick.classList.toggle("on-white", r.top<=barBottom+2 && r.bottom>barBottom);
  }
  /* re-evaluate on every scroll event AND once the scroll has settled: with
     scroll-behavior:smooth the last scroll event fires mid-flight, and the bar's state
     would otherwise reflect wherever that was rather than where the page stopped */
  var settle=null;
  var onScroll2=function(){ check(); tint(); clearTimeout(settle); settle=setTimeout(function(){ check(); tint(); },160); };
  stickyOn("scroll",onScroll2,{passive:true});
  stickyOn("scrollend",onScroll2);
  stickyOn("resize",onScroll2);
  stickyOn("hashchange",onScroll2);
  stick._cbCleanup=function(){stickyAbort.abort();clearTimeout(settle);};
  check(); tint();
  /* an anchored load ("/?view=about#how-it-works") jumps AFTER this runs, and the jump does
     not always fire a scroll event — poll a few times while the page settles */
  [120,400,900].forEach(function(t){ setTimeout(function(){ check(); tint(); },t); });
}

/* ---------------- scroll reveal ----------------
   Each element builds in ONCE, the first time it reaches the viewport; afterwards the
   classes are stripped so pages keep full control of their own transforms.
   An IntersectionObserver drives it, with a scroll fallback so nothing can ever be
   left stranded at opacity 0 (a backgrounded tab stops delivering IO callbacks). */
var CBREVEAL={
  init:function(selectors,opts){
    opts=opts||{};
    /* Reduced motion means no big movement, not no feedback — the build becomes a
       plain cross-fade instead of being switched off. */
    var calm=matchMedia("(prefers-reduced-motion:reduce)").matches;
    var els=[], alwaysSel=(opts.always||[]).join(",");
    (typeof selectors==="string"?[selectors]:selectors).forEach(function(sel){
      [].forEach.call(document.querySelectorAll(sel),function(el){
        /* skip anything this breakpoint hides — it would never intersect, and would be
           stuck invisible if a resize later revealed it */
        if(el.offsetParent===null&&getComputedStyle(el).position!=="fixed") return;
        /* Never hide content already visible on the first paint. Entry animation is for
           below-the-fold discovery; the ordering UI must stay immediately usable. */
        var firstRect=el.getBoundingClientRect(),viewportH=window.innerHeight||document.documentElement.clientHeight;
        /* opts.always: a sequence the page holds hidden from its first paint (About's steps) still builds on arrival */
        if(!(alwaysSel&&el.matches(alwaysSel))&&firstRect.bottom>0&&viewportH>firstRect.top) return;
        if(0>els.indexOf(el)) els.push(el);
      });
    });
    /* The pre-paint hide (html.rv-boot) comes off once the hidden classes are on AND the
       fonts are in — so the first paint can never be in fallback faces (that reflow was the
       "page refreshes itself"). Nothing reveals before boot, or it would animate unseen. */
    var booted=false, quickUntil=0;
    var boot=function(){
      if(booted) return; booted=true;
      document.documentElement.classList.remove("rv-boot");
      quickUntil=performance.now()+1200;          /* everything that reveals in the first second is the load batch */
      if(window.requestAnimationFrame) requestAnimationFrame(function(){ requestAnimationFrame(sweep); });
      setTimeout(sweep,60);
    };
    var whenFonts=(document.fonts&&document.fonts.ready)?document.fonts.ready:Promise.resolve();
    if(!els.length){ whenFonts.then(boot,boot); return; }
    var step=opts.stagger==null?140:opts.stagger, maxStep=opts.maxStagger==null?560:opts.maxStagger;
    var flatSel=(opts.flat||[]).join(",");
    /* Anything that blends with the page — or CONTAINS something that does, which is the
       real case: the About illustration sits inside a plain wrapper — must never be given
       an opacity < 1. That isolates the subtree into its own group, the blend stops
       applying, and the artwork's white paper flashes in. Those slide in on transform. */
    function blends(el){
      if(getComputedStyle(el).mixBlendMode!=="normal") return true;
      var kids=el.querySelectorAll("*");
      for(var i=0;kids.length>i&&40>i;i++){ if(getComputedStyle(kids[i]).mixBlendMode!=="normal") return true; }
      return false;
    }
    els.forEach(function(el){
      var cs=getComputedStyle(el);
      if(blends(el)) el.classList.add("rv-blend");
      else if(calm||(flatSel&&el.matches(flatSel))) el.classList.add("rv-flat");   /* `translate` composes with an element's own transform, so rotated cards can move too */
      el.classList.add("rv");
    });
    /* Resolve the hidden state BEFORE anything can be revealed. Without this forced
       reflow the browser coalesces .rv and .rv-in into one style recalculation, the
       element never actually holds opacity 0, and no transition runs — the blocks just
       appear. Chrome sometimes got away with it because other work forced a layout;
       Safari never did, which is why no page anywhere appeared to build. */
    void document.documentElement.offsetHeight;
    var pending=els.slice();
    /* The build runs on the Web Animations API rather than a CSS transition. A
       transition only fires if the browser committed the hidden state in a separate
       style recalculation first, and that is not reliable when the class that hides
       the element and the class that shows it are added a frame apart — Safari
       skipped straight to the end, so nothing appeared to build at all. An explicit
       animation cannot be short-circuited that way. */
    var DUR=1500, EASE="cubic-bezier(.22,1,.36,1)";
    function nextFrame(fn){
      if(document.hidden||!window.requestAnimationFrame){ setTimeout(fn,50); return; }
      requestAnimationFrame(function(){ setTimeout(fn,0); });    /* after the frame has painted, not before */
    }
    function reveal(el,delay,quick){
      var i=pending.indexOf(el); if(0>i) return; pending.splice(i,1);
      var dur=quick?900:DUR;
      if(io) io.unobserve(el);
      var blend=el.classList.contains("rv-blend");
      var flat=!blend&&(calm||el.classList.contains("rv-flat"));
      if(!el.animate){                                   /* no WAAPI: fall back to the classes */
        el.style.transitionDelay=delay+"ms";
        el.classList.add("rv-in");
        setTimeout(function(){ el.classList.remove("rv","rv-in","rv-flat","rv-blend"); el.style.transitionDelay=""; },delay+DUR+300);
        return;
      }
      /* The hidden class STAYS ON for the whole run. A running animation outranks a CSS
         declaration, so it drives the element from the first committed frame, and
         `fill:both` holds the start state through the stagger delay and the end state
         after. Removing .rv first — as this used to — leaves a window where the element
         is already visible but the animation has not been committed yet; Chrome closed
         that window in the same frame, Safari did not, so blocks just appeared.
         `transition:none` is pinned so a page's own transition (the grid cards carry one)
         cannot animate the same jump underneath. */
      el.style.transition="none";
      var from=blend?{translate:"0 56px"}:flat?{opacity:0}:{opacity:0,translate:"0 56px"};
      var to  =blend?{translate:"0 0"}   :flat?{opacity:1}:{opacity:1,translate:"0 0"};
      var a=el.animate([from,to],{duration:calm?400:dur,delay:delay,easing:flat?"ease":EASE,fill:"both"});
      /* classes off first, then cancel — same task, so there is no frame at opacity 0 */
      /* Teardown is staged across frames. Safari treats "class off + cancel() + page
         transition back on" in one task as a real style change on the element's own
         `transition:opacity` (the grid cards carry one): the finished cards faded out
         and back in ~1.5s after they had built, which read as the page refreshing.
         Frame 1: hidden classes off — the filled animation still holds the same values,
         so nothing moves. Frame 2: drop the animation — the base style already matches.
         Frame 3: hand the element its own transitions back, with nothing left to animate. */
      var torn=false;
      var done=function(){
        if(torn) return; torn=true;
        el.classList.remove("rv","rv-flat","rv-blend");
        var drop=function(){ try{ a.cancel(); }catch(e){} nextFrame(function(){ el.style.transition=""; }); };
        nextFrame(drop);
      };
      if(a.finished&&a.finished.then) a.finished.then(done,done);
      /* Hard floor on a plain timer: a document timeline that never advances (a
         backgrounded tab) would otherwise leave the fill holding the element hidden
         forever. setTimeout still fires there. */
      setTimeout(done,delay+(calm?400:dur)+700);
    }
    /* due = the block is SUBSTANTIALLY on screen: its top has come up to 62% of the
       viewport (measured: at 86% every scroll reveal started with ~170px of a 550px card
       showing, at the bottom edge, and was finished before the eye reached it — that is
       why the build was only ever noticed on load). A short block that fits entirely on
       screen below that line counts too, so the last blocks of a page can still reveal.
       Anything already scrolled PAST counts, so a jump down never strands a block. */
    /* due = any part of the block is on screen. Anything visible at load builds at once —
       hiding blocks that are already in the viewport just reads as missing content (the
       "only the first row" bug). On scroll a block fires as it ENTERS from the bottom; the
       1.5s / 56px build is slow and big enough that it is still moving when the block is
       mid-screen. Anything scrolled PAST counts too, so a jump can never strand a block. */
    function due(el){ return innerHeight*0.96>el.getBoundingClientRect().top; }
    /* Order a batch top-to-bottom, left-to-right. Siblings marked data-rv-seq are a SEQUENCE (About's
       step · arrow · step · arrow · step, owner 2026-09-16): whichever member comes due pulls in the rest,
       and they build in seq order, opts.seqStep ms apart, instead of by position. */
    function schedule(hits){
      hits.slice().forEach(function(el){
        if(el.dataset.rvSeq==null) return;
        [].forEach.call(el.parentNode.children,function(s){ if(s.dataset&&s.dataset.rvSeq!=null&&pending.indexOf(s)>=0&&0>hits.indexOf(s)) hits.push(s); });
      });
      hits.sort(function(a,b){
        if(a.dataset.rvSeq!=null&&b.dataset.rvSeq!=null&&a.parentNode===b.parentNode) return a.dataset.rvSeq-b.dataset.rvSeq;
        var x=a.getBoundingClientRect(),y=b.getBoundingClientRect(); return x.top-y.top||x.left-y.left;
      });
      /* the load-time batch fills the viewport promptly (tight stagger); scroll reveals keep the slow build */
      var quick=quickUntil>performance.now(), st=quick?60:step, mx=quick?240:maxStep, seqBase=null, seqStep=opts.seqStep||240;
      hits.forEach(function(el,i){
        var d=Math.min(i*st,mx);
        if(el.dataset.rvSeq!=null){ if(seqBase===null) seqBase=d; d=seqBase+(+el.dataset.rvSeq)*seqStep; }
        reveal(el,d,quick);
      });
    }
    function sweep(){
      /* pending is still unset when init returned early because every target was already on
         screen (short pages such as the bag on phones) and boot scheduled this sweep anyway */
      if(!booted||!pending) return;
      var hits=pending.filter(due);
      if(!hits.length) return;
      schedule(hits);
      if(!pending.length){ removeEventListener("scroll",onScroll); removeEventListener("resize",sweep); }
    }
    var tick=false;
    /* rAF is the smooth path, but a backgrounded tab never runs it — fall back to a timer */
    function onScroll(){
      if(tick) return; tick=true;
      var run=function(){ tick=false; sweep(); };
      if(document.hidden||!window.requestAnimationFrame) setTimeout(run,60); else requestAnimationFrame(run);
    }
    var io=null;
    if(window.IntersectionObserver){
      io=new IntersectionObserver(function(entries){
        if(!booted) return;                        /* the boot sweep handles the load batch */
        var hits=entries.filter(function(e){return e.isIntersecting;}).map(function(e){return e.target;});
        if(!hits.length) return;
        schedule(hits);
      },{rootMargin:opts.rootMargin||"0px 0px -4% 0px",threshold:0.01});
      els.forEach(function(el){ io.observe(el); });
    }
    addEventListener("scroll",onScroll,{passive:true});
    addEventListener("resize",sweep);
    whenFonts.then(boot,boot);
    setTimeout(boot,2200);                                           /* failsafe: never wait on fonts forever */
    setTimeout(sweep,900);                                           /* again once images have settled */
    /* last resort: nothing may stay stranded at opacity 0 */
    var beat=setInterval(function(){ if(!pending.length){ clearInterval(beat); return; } sweep(); },1200);
  }
};

/* ---------------- fly-to-bag FX ---------------- */
/* body zoom (fitScale) moves the fixed-layer coordinate space: measure it */
function calib(){
  var p=document.createElement("div");p.style.cssText="position:fixed;left:0;top:0;width:100px;height:1px;pointer-events:none;visibility:hidden";
  document.body.appendChild(p);var r=p.getBoundingClientRect();var k=(r.width/100)||1,ox=r.left,oy=r.top;p.remove();
  return {k:k,toLocal:function(vx,vy){return {x:(vx-ox)/k,y:(vy-oy)/k};}};
}
function starBurst(el){
  if(!el)return;var cal=calib();var r=el.getBoundingClientRect();if(!r.width)return;var c=cal.toLocal(r.left+r.width/2,r.top+r.height/2);
  var host=document.createElement("div");host.className="cb-stars";host.style.left=c.x+"px";host.style.top=c.y+"px";
  var cols=["#143e76","#ff9e54","#e95330","#ffffff"];
  for(var i=0;9>i;i++){var ang=(i/9)*Math.PI*2+Math.random()*.5,dist=26+Math.random()*30;var s=document.createElementNS("http://www.w3.org/2000/svg","svg");var sz=6+Math.random()*8;
    s.setAttribute("width",sz);s.setAttribute("height",sz);s.setAttribute("viewBox","0 0 10 10");s.innerHTML='<path d="M5 0 L6.1 3.9 L10 5 L6.1 6.1 L5 10 L3.9 6.1 L0 5 L3.9 3.9 Z" fill="'+cols[i%4]+'"/>';
    s.style.setProperty("--dx",Math.cos(ang)*dist+"px");s.style.setProperty("--dy",Math.sin(ang)*dist+"px");s.style.setProperty("--sc",(0.9+Math.random()*.9).toFixed(2));s.style.setProperty("--rot",(Math.random()*180-90).toFixed(0)+"deg");s.style.animationDelay=(Math.random()*.12)+"s";host.appendChild(s);}
  document.body.appendChild(host);setTimeout(function(){host.remove();},950);
}
function bump(el,cls){ if(!el) return; cls=cls||"cb-bump"; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function(){ el.classList.remove(cls); },700); }
/* a little disc with the product photo arcs from `src` to `dst` (both elements or rects) */
function fly(o){
  var src=o.src, dst=o.dst; if(!src||!dst) { if(o.onLand) o.onLand(); return; }
  var cal=calib();
  var ra=src.getBoundingClientRect?src.getBoundingClientRect():src, rb=dst.getBoundingClientRect?dst.getBoundingClientRect():dst;
  if(!ra.width||!rb.width){ if(o.onLand) o.onLand(); return; }
  var p0=cal.toLocal(ra.left+ra.width/2,ra.top+ra.height/2), p1=cal.toLocal(rb.left+rb.width/2,rb.top+rb.height/2);
  var S=o.size||64, el=document.createElement("div"); el.className="cb-fly"; el.style.width=el.style.height=S+"px";
  var im=document.createElement("img"); im.src=o.img||""; im.alt=""; if(o.imgStyle) im.style.cssText=o.imgStyle; el.appendChild(im); document.body.appendChild(el);
  var dist=Math.hypot(p1.x-p0.x,p1.y-p0.y), lift=Math.min(260,Math.max(120,dist*.35));
  var cp={x:(p0.x+p1.x)/2,y:Math.min(p0.y,p1.y)-lift};
  el.style.offsetPath='path("M '+p0.x.toFixed(1)+' '+p0.y.toFixed(1)+' Q '+cp.x.toFixed(1)+' '+cp.y.toFixed(1)+' '+p1.x.toFixed(1)+' '+p1.y.toFixed(1)+'")';
  el.style.offsetRotate="0deg";
  var anim=el.animate([
    {offsetDistance:"0%",transform:"scale(.5) rotate(-10deg)",opacity:0},
    {offsetDistance:"9%",transform:"scale(1.12) rotate(5deg)",opacity:1,offset:.12},
    {offsetDistance:"30%",transform:"scale(1) rotate(-6deg)",offset:.34},
    {offsetDistance:"62%",transform:"scale(.8) rotate(4deg)",offset:.62},
    {offsetDistance:"94%",transform:"scale(.4) rotate(-2deg)",opacity:1,offset:.92},
    {offsetDistance:"100%",transform:"scale(.28) scaleX(1.25)",opacity:.85}],{duration:o.duration||840,easing:"cubic-bezier(.35,.02,.3,1)",fill:"forwards"});
  anim.onfinish=function(){ el.remove(); if(o.onLand) o.onLand(); };
}
/* the bag icon in whichever nav is showing (desktop icon nav or the mobile header icons) */
function navBagIn(root){
  root=root||document;
  var els=root.querySelectorAll('.cbn-icons a[data-nav="bag"] .icon, .iconnav a[data-nav="bag"] .icon, .cbn-mob.icons a[data-nav="bag"], .mob-icons a[data-nav="bag"]');
  for(var i=0;els.length>i;i++){ var r=els[i].getBoundingClientRect(); if(r.width&&r.height) return els[i]; }
  return null;
}
function badgeNear(icon){ var a=icon.closest("a"); return a?a.querySelector("[data-cb-badge]"):null; }
/* fly a product into the global-nav bag. If the nav has scrolled away, a copy of it
   drops down first, catches the product, shows the new count, then slides away. */
function flyToNavBag(src,img,onLand,imgStyle){
  var icon=navBagIn(document), r=icon&&icon.getBoundingClientRect();
  var visible=icon&&r.top>=0&&r.bottom<=innerHeight;
  function land(target){
    if(onLand) onLand();
    var a=target.closest("a"); if(a){ a.classList.remove("landed"); void a.offsetWidth; a.classList.add("landed"); setTimeout(function(){a.classList.remove("landed");},900); }
    var b=badgeNear(target); if(b){ b.classList.remove("pop"); void b.offsetWidth; b.classList.add("pop"); }
    starBurst(target);
  }
  if(visible){ fly({src:src,dst:icon,img:img,imgStyle:imgStyle,onLand:function(){ land(icon); }}); return; }
  /* the sticky bar is already on screen — fly into its bag rather than dropping a second one */
  var stick=document.querySelector(".cbn-stick.show");
  if(stick){
    var st=navBagIn(stick);
    if(st){ fly({src:src,dst:st,img:img,imgStyle:imgStyle,onLand:function(){ land(st); }}); return; }
  }
  /* peek nav */
  var header=document.querySelector("[data-cb-header], .nav#nav");
  if(!header){ if(onLand) onLand(); return; }
  var old=document.querySelector(".cbn-peek"); if(old) old.remove();
  var peek=document.createElement("div"); peek.className="cbn-peek";
  var clone=header.cloneNode(true); clone.removeAttribute("id"); clone.querySelectorAll("[id]").forEach(function(n){n.removeAttribute("id");});
  peek.appendChild(clone); document.body.appendChild(peek); updateBadges();
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ peek.classList.add("show"); }); });
  setTimeout(function(){
    var t=navBagIn(peek);
    fly({src:src,dst:t||peek,img:img,imgStyle:imgStyle,onLand:function(){
      if(t) land(t); else if(onLand) onLand();
      setTimeout(function(){ peek.classList.remove("show"); setTimeout(function(){ peek.remove(); },500); },1100);
    }});
  },460);
}
var CBFX={calib:calib,fly:fly,starBurst:starBurst,bump:bump,flyToNavBag:flyToNavBag,navBagIn:navBagIn,updateBadges:updateBadges};

/* ---------------- shared date picker (CBCAL) ----------------
   The checkout calendar from bag.html, available to any field: CBCAL.open(wrapper,{value,min,
   allow,onPick,clear}) drops the popover into `wrapper` (which must be position:relative). */
var CBCAL=(function(){
  var MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];
  var MON3=["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
  var DOWS=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  var CHEV='<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="%d" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  var el=null, wrap=null, opts=null, month=null;
  var pad=function(n){ return (n<10?"0":"")+n; };
  function sameDay(a,b){ return !!a&&!!b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
  function fmt(d){ return DOWS[d.getDay()]+" – "+pad(d.getDate())+" "+MON3[d.getMonth()]+" "+d.getFullYear(); }
  function iso(d){ return d.getFullYear()+"-"+pad(d.getMonth()+1)+"-"+pad(d.getDate()); }
  function midnight(d){ return new Date(d.getFullYear(),d.getMonth(),d.getDate()); }
  function build(){
    var m=month, start=new Date(m.getFullYear(),m.getMonth(),1).getDay();
    var days=new Date(m.getFullYear(),m.getMonth()+1,0).getDate();
    var min=opts.min?midnight(opts.min):midnight(new Date());
    var cells=["Su","Mo","Tu","We","Th","Fr","Sa"].map(function(d){ return '<span class="dow">'+d+'</span>'; }).join("");
    /* the comparison is written this way round on purpose: a less-than followed by a letter
       makes theme-check parse the rest of the file as an unclosed HTML tag */
    for(var i=0;start>i;i++) cells+="<span></span>";
    for(var d=1;days>=d;d++){
      var dt=new Date(m.getFullYear(),m.getMonth(),d);
      var ok=dt>=min&&(!opts.allow||opts.allow(dt));
      cells+='<button type="button" class="day" '+(ok?"":"disabled")+' data-d="'+d+'" data-sel="'+sameDay(dt,opts.value)+'" aria-pressed="'+sameDay(dt,opts.value)+'" aria-label="'+fmt(dt)+'">'+d+"</button>";
    }
    el.innerHTML='<div class="cbcal-head">'+
      '<button type="button" data-nav="-1" aria-label="Previous month">'+CHEV.replace("%d","M8.6 3.5 5.3 7l3.3 3.5")+'</button>'+
      '<span class="m" aria-live="polite" aria-atomic="true">'+MONTHS[m.getMonth()]+" "+m.getFullYear()+'</span>'+
      '<button type="button" data-nav="1" aria-label="Next month">'+CHEV.replace("%d","M5.4 3.5 8.7 7 5.4 10.5")+'</button></div>'+
      '<div class="cbcal-grid">'+cells+'</div>'+
      (opts.clear?'<button type="button" class="cbcal-clear">'+opts.clear+'</button>':"");
  }
  function close(restoreFocus){ if(!isOpen())return;el.classList.remove("show");if(wrap){var b=wrap.querySelector('[aria-expanded]');if(b){b.setAttribute("aria-expanded","false");if(restoreFocus!==false&&b.isConnected)b.focus();}} }
  function isOpen(){ return !!el&&el.classList.contains("show"); }
  function open(w,o){
    if(isOpen()&&wrap===w){ close(); return; }
    if(isOpen())close(false);
    wrap=w; opts=o||{};
    if(!el){
      el=document.createElement("div"); el.className="cbcal";
      el.addEventListener("click",function(e){
        e.stopPropagation();
        var nav=e.target.closest("[data-nav]"), day=e.target.closest(".day:not(:disabled)"), clr=e.target.closest(".cbcal-clear");
        if(nav){var direction=nav.dataset.nav;month=new Date(month.getFullYear(),month.getMonth()+ +direction,1);build();el.querySelector('[data-nav="'+direction+'"]').focus();return;}
        if(day){ var d=new Date(month.getFullYear(),month.getMonth(),+day.dataset.d); opts.value=d; if(opts.onPick) opts.onPick(d); close(); return; }
        if(clr){ opts.value=null; if(opts.onPick) opts.onPick(null); close(); }
      });
      document.addEventListener("click",function(e){ if(isOpen()&&!e.target.closest(".cbcal")&&!(wrap&&wrap.contains(e.target))) close(false); });
      el.addEventListener("keydown",function(e){if(e.key==="Escape"){e.preventDefault();e.stopPropagation();close();}});
    }
    if(el.parentNode!==w) w.appendChild(el);
    month=new Date((opts.value||opts.min||new Date()).getFullYear(),(opts.value||opts.min||new Date()).getMonth(),1);
    build(); el.classList.add("show");
    var b=w.querySelector('[aria-expanded]'); if(b) b.setAttribute("aria-expanded","true");
    var selected=el.querySelector('.day[data-sel="true"]:not(:disabled)')||el.querySelector('.day:not(:disabled)')||el.querySelector('[data-nav="1"]');if(selected)selected.focus();
  }
  return {open:open,close:close,isOpen:isOpen,fmt:fmt,iso:iso,sameDay:sameDay};
})();

window.CBNAV=CBNAV; window.CBREVEAL=CBREVEAL; window.CBCart=CBCart; window.CBCART=CBCART; window.CBEXTRAS=CBEXTRAS; window.CBFX=CBFX; window.CBCAL=CBCAL;
})();
